import ExtendedHorizontalTool from './ExtendedHorizontalTool.js';

class ExtendedHorizontalToolResistance extends ExtendedHorizontalTool {
	get flavor() {
		return 'resistance';
	}
}

export default ExtendedHorizontalToolResistance;
